import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../providers/auth.service';
import { MatSnackBar, MatDialog } from '@angular/material';
import { RecaptchaComponent } from 'angular-google-recaptcha';
import { Globals } from '../../../globals';
import { RecuperarDialog } from '../../../forms/usuarios/recuperar-dialog/recuperar-dialog.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { GeneralService } from '../../../providers/general.service';
import { TemaService } from '../../../providers/tema.service';

@Component({
  selector: 'app-ingreso',
  templateUrl: './ingreso.component.html',
  styleUrls: ['./ingreso.component.scss']
})
export class IngresoComponent implements OnInit {
  recaptcha: boolean;
  model: any = {};
  cargando = true;
  error = '';
  hide: boolean;
  nombreEmpresa: any;

  @ViewChild(RecaptchaComponent) recaptchaContainer: RecaptchaComponent;

  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);
  contrasenaFormControl = new FormControl('', [
    Validators.required
  ]);
  tema: String = '';

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private snackbar: MatSnackBar,
    public globals: Globals,
    private dialog: MatDialog,
    public deviceService: DeviceDetectorService,
    public general: GeneralService,
    private temaServicio: TemaService
  ) { }

  ngOnInit() {
    // reset login status
    // localStorage.setItem('idCliente','53');
    this.authenticationService.logout();
    location.replace('https://gestion.itego.com.ar/public/login');
    // this.temaServicio.tema.subscribe(temaSeleccionado => this.tema = temaSeleccionado);
    // this.nombreEmpresa = localStorage.getItem('nombreCliente')
  }

  onRecatchaLoad() { // cargo el catpcha
    this.cargando = false;
  }

  onRecatchaError() {
    this.error = 'Error de captcha';
  }

  onInput() {
    this.error = '';
  }

  login() {
    if (this.emailFormControl.hasError('required') ||
      this.emailFormControl.hasError('email') ||
      this.contrasenaFormControl.hasError('required') ||
      !this.recaptcha) {
      // en caso de error en los datos del formulario
      this.error = 'Revise los datos solicitados y el captcha';
    } else { // si el formulario es correcto
      this.cargando = true;

      this.authenticationService.login(this.model.email, this.model.contrasena).subscribe(
        respuesta => {
          if (respuesta.estado == 1) {
            // remover mensajes viejos
            this.snackbar.dismiss();
            // localStorage.setItem('idCliente','21');
            // ingreso al sistema
            this.router.navigate(['/']);
          } else {
            // error en el servidor
            this.error = respuesta.mensaje;
          }

          this.cargando = false;
        },
        error => {
          this.cargando = false;
          this.error = error;
        }
      );
    }
  }

  openDialogRecuperar(): void {
    this.dialog.open(RecuperarDialog, {
      disableClose: true
    });
  }
}
